export * from './ETipo';
